import React, { Component } from "react";
import ROUTES from "../../constants/routes";
import { NavLink, withRouter } from "react-router-dom";

import "./NavigationTabs.sass";

class PromotersPromoterNavTabs extends Component {
  goToPage = (route) => {
    return route.replace(":promoterId", this.props.match.params.promoterId);
  };

  render() {
    const links = [
      {
        title: 'Info',
        route: ROUTES.PROMOTERS_PROMOTER_INFO,
      },
      {
        title: 'Maps',
        route: ROUTES.PROMOTERS_PROMOTER_MAPS,
      },
      {
        title: 'Payments',
        route: ROUTES.PROMOTERS_PROMOTER_PAYMENTS,
      },
    ];

    return (
      <nav className="nav-tabs">
        <div className="nav-tabs__container nav-tabs__container--small">
          {links.map(link => {
            return (
              <NavLink
                className="nav-tabs__item"
                to={this.goToPage(link.route)}
                key={link.route}
              >
                <span>{link.title}</span>
              </NavLink>
            )
          })}
        </div>
      </nav>
    ); 
  }
};

export default withRouter(PromotersPromoterNavTabs);

